export const getScreenSize = () => {
  let width = 0;
  let height = 0;
  let pageYOffset = 0;
  if (typeof window !== "undefined") {
    width = window.innerWidth;
    height = window.innerHeight;
    pageYOffset = window.pageYOffset;
  }
  const isMobile = width <= 768;
  const isTablet = width > 768 && width <= 992;
  const isDesktop = width > 992;
  return { width, height, pageYOffset, isMobile, isTablet, isDesktop };
};

export const getCurrentScreen = () => {
  let width = 0;
  if (typeof window === "undefined") {
    return "not-available";
  }
  width = window.innerWidth;
  let screen = "mobile";
  if (width > 768 && width <= 992) {
    screen = "tablet";
  }
  if (width > 992) {
    screen = "desktop";
  }
  return screen;
};

